export default "__VITE_ASSET__Rul0cTWE__"